import React from "react";
import { Card, CardBody, CardHeader, CardTitle, Container, Row, Col } from "reactstrap";
import { useTranslation } from "../../hooks/useTranslation";

const AboutPage = () => {
  const t = useTranslation();

  return (
    <div className="content">
      <Container fluid>
        <Row>
          <Col md="12">
            <Card>
              <CardHeader>
                <CardTitle tag="h2">
                  {t("client.about") || "About Us"}
                </CardTitle>
              </CardHeader>
              <CardBody>
                <p>
                  {t("client.aboutDescription") || 
                    "Learn more about our company, mission, and values."}
                </p>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default AboutPage;

